import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/fly.png'


const _hoisted_1 = { class: "_change-status _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 md-down:px-6 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Luca Education",
      title: "Luca Education",
      height: "150",
      width: "150"
    })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }, " Chia sẻ báo cáo ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500 mt-2" }, " Để chia sẻ báo cáo, bạn hãy ấn sao chép đường dẫn ", -1)
const _hoisted_6 = { class: "w-full mt-5" }
const _hoisted_7 = {
  key: 0,
  class: "w-full mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded-md bg-green-50 p-4 shadow-input\"><div class=\"flex\"><div class=\"flex-shrink-0\"><svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5ZM13.7071 9.20711C14.0976 8.81658 14.0976 8.18342 13.7071 7.79289C13.3166 7.40237 12.6834 7.40237 12.2929 7.79289L9 11.0858L7.70711 9.79289C7.31658 9.40237 6.68342 9.40237 6.29289 9.79289C5.90237 10.1834 5.90237 10.8166 6.29289 11.2071L8.29289 13.2071C8.68342 13.5976 9.31658 13.5976 9.70711 13.2071L13.7071 9.20711Z\" fill=\"#2AA797\"></path></svg></div><div class=\"ml-3\"><p class=\"text-sm font-medium text-green-800 whitespace-nowrap\"> Sao chép đường dẫn thành công </p></div></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "px-4 py-3 shadow-input rounded-md text-blue-600 text-center truncate" }
const _hoisted_11 = { class: "flex flex-nowrap items-center mt-6 md-down:flex-col-reverse" }
const _hoisted_12 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_ctx.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx._path), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "button-p text-center btn--text whitespace-nowrap",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPath && _ctx.openPath(...args)))
        }, " Mở đường dẫn "),
        _createElementVNode("button", {
          type: "button",
          class: "button-p text-center whitespace-nowrap ml-12 md-down:ml-0 md-down:mb-4",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyPath && _ctx.copyPath(...args)))
        }, " Sao chép đường dẫn ")
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, " Thoát ")
    ])
  ]))
}